var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"overline"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('ul',_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[(item[_vm.key1])?_c('span',[_vm._v(_vm._s(_vm.concToPercent(item[_vm.key1])))]):_vm._e(),(item[_vm.key2])?_c('span',[_vm._v(" "+_vm._s(item[_vm.key2]))]):_vm._e()])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }